export interface BonusesInterface {
    count: number
}

export enum CalcMode {
    Client = 'client',
    Agent = 'agent',
}

export default interface GlobalOptionsInterface {
    calcMode: CalcMode
    rootNodeId: string
    code: string
    isDemo?: boolean
    pid?: string
    bonuses?: BonusesInterface
    clientIsn?: string
    dinamyc: {
        test: boolean
    }
    returnUrl?: string
    optionsForCreatePolicy?: {
        [key: string]: any
    }
    partnerParams?: {
        [key: string]: any
    }
    options?: {
        programCode?: string
    }
    hidePromocode?: boolean
    initialValues?: {
        promocode?: string
        insurant?: {
            firstName?: string
            lastName?: string
            middleName?: string
            birthday?: string // YYYY-MM-DD
            passportSerial?: string
            passportNumber?: string
            passportDateOfIssue?: string // YYYY-MM-DD
            email?: string
            phone?: string // без +7 в любом формате, всегда отображает как РФ
            address?: string
        }
    }
}
